import * as PropTypes from 'prop-types';
import * as React from 'react';

import { IOfferHelper } from '../../../presenter';

import * as styles from './index.css';

export interface ITitleContext {
  offerHelper: IOfferHelper;
}

export interface ITitleProps {
  isDealRentCianAgency?: boolean;
}

export class Title extends React.Component<ITitleProps> {
  public context: ITitleContext;

  public static contextTypes = {
    offerHelper: PropTypes.object,
  };

  public render() {
    return (
      <div className={styles['title']}>
        {
          [
            this.getType(),
            this.renderArea(),
            this.renderFloor(),
            this.renderFoolrsForSuburban(),
            this.renderBedroomCount(),
          ]
            .filter(Boolean)
            .join(', ')
        }
      </div>
    );
  }

  protected getType = () => {
    const type = this.context.offerHelper.simplifiedCard.getType();

    return `${type.charAt(0).toUpperCase()}${type.substring(1)}`;
  }

  protected renderArea(): string | null {
    const roomArea = this.context.offerHelper.presenters.getRoomArea();
    const totalArea = this.context.offerHelper.presenters.getTotalArea();

    const isSuburban = this.context.offerHelper.isSuburban();
    const isFlat = this.context.offerHelper.isFlat();
    const isBed = this.context.offerHelper.isBed();

    const landArea = isSuburban && this.context.offerHelper.simplifiedCard.getLandArea();

    if (isBed && totalArea) {
      return `${totalArea} м\u00B2`;
    }

    if (isFlat && roomArea) {
      return `${roomArea} м\u00B2`;
    } else if (totalArea) {
      return `${totalArea} м\u00B2`;
    }

    if (isSuburban && landArea) {
      return landArea;
    }

    return null;
  }

  protected renderFloor(): string | null {
    const isSuburban = this.context.offerHelper.isSuburban();
    const isGarage = this.context.offerHelper.isGarage();

    if (!isSuburban && !isGarage) {
      return this.context.offerHelper.simplifiedCard.getFloorRange();
    }

    return null;
  }

  protected renderBedroomCount(): string | null {
    const isSuburban = this.context.offerHelper.isSuburban();

    if (isSuburban) {
      return this.context.offerHelper.presenters.getBedroomsCount();
    }

    return null;
  }

  protected renderFoolrsForSuburban(): string | void | null {
    const isSuburban = this.context.offerHelper.isSuburban();

    if (isSuburban) {
      return this.context.offerHelper.presenters.getFloorCount();
    }

    return null;
  }
}
